export const getSiteSettingsRoute = () => '/settings';
export const getSiteFinancialReportRoute = () => '/financial-report';
export const getSiteAddressRoute = () => '/address';
